module.exports = __webpack_public_path__ + "img/emotion-ethical@2x.98a5255.jpg";